export class WindowSize {
  static readonly MIN_WINDOW_HEIGHT = 250
  static readonly MIN_WINDOW_WIDTH = 300

  static get width(): number {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    )
  }

  static get height(): number {
    return (
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
    )
  }

  static isWindowTooSmall(): boolean {
    return (
      WindowSize.height <= WindowSize.MIN_WINDOW_HEIGHT &&
      WindowSize.width <= WindowSize.MIN_WINDOW_WIDTH
    )
  }
}
